module.exports = __webpack_public_path__ + "static/media/制式1.aac096fa.jpg";